import React, { useEffect, useState } from "react";
import "../../styles/styles.css";
import axios from "axios";
import "suneditor/dist/css/suneditor.min.css";
import parse from "html-react-parser";
import { useSelector } from "react-redux";

const API_URL = process.env.REACT_APP_API_URL;
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

const PageArticle = () => {
  const [article, setArticle] = useState({
    _id: "",
    image: "",
    date: "",
    titre: "",
    description: "",
    index: 0,
    categorie: "",
    href: "",
    html: "",
  });

  const [commentaires, setCommentaires] = useState([]);
  const [nom, setNom] = useState("");
  const [commentaire, setCommentaire] = useState("");
  const [message, setMessage] = useState("");

  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    const getArticle = async () => {
      try {
        const response = await axiosInstance.get(
          "api/articles" + window.location.pathname
        );
        setArticle(response.data);

        if (response.data._id) {
          getCommentaires(response.data._id);
        }
      } catch (error) {
        console.log("erreur:", error);
      }
    };
    getArticle();
  }, []);

  const getCommentaires = async (idArticle) => {
    try {
      const res = await axiosInstance.get(`api/commentaire/${idArticle}`);
      setCommentaires(res.data || []);
    } catch (error) {
      console.log("Erreur récupération commentaires:", error);
    }
  };

  const handleAjouterCommentaire = async () => {
    if (!nom.trim() || !commentaire.trim()) {
      setMessage("Veuillez remplir tous les champs.");
      return;
    }

    try {
      const payload = { idArticle: article._id, nom, commentaire };
      await axiosInstance.post("api/commentaire/", payload);
      setMessage("✅ Commentaire ajouté avec succès !");
      setNom("");
      setCommentaire("");
      getCommentaires(article._id);
    } catch (error) {
      console.log("Erreur post commentaire:", error);
      setMessage("❌ Erreur lors de l'ajout du commentaire.");
    }
  };

  const handleSupprimerCommentaire = async (commentId) => {
    if (!window.confirm("Voulez-vous vraiment supprimer ce commentaire ?")) return;

    try {
      await axiosInstance.delete(`api/commentaire/${commentId}`);
      setMessage("Commentaire supprimé ✅");
      getCommentaires(article._id);
    } catch (error) {
      console.error("Erreur suppression commentaire:", error);
      setMessage("❌ Impossible de supprimer le commentaire.");
    }
  };

  return (
    <div
      style={{
        marginLeft: "50px",
        marginRight: "50px",
        marginTop: "50px",
        textAlign: "justify",
      }}
      className="article-container"
    >
      <div className="article page">
        {article.html &&
          parse(
            article.html
              .replaceAll(
                "linkpdf",
                "<img src='https://www.ahuncycle.com/images/pdf.png' />"
              )
              
          )}
      </div>

      {/* Section Commentaires */}
      <div
        style={{
          marginTop: "60px",
          padding: "20px",
          borderTop: "1px solid #ccc",
        }}
      >
        <h3>Commentaires</h3>

        {/* Liste des commentaires */}
        <div style={{ marginBottom: "20px" }}>
          {commentaires.length > 0 ? (
            commentaires.map((c, idx) => {
              const date =
                c.date || c.createdAt
                  ? new Date(c.date || c.createdAt).toLocaleDateString("fr-CA")
                  : "";

              return (
                <div
                  key={idx}
                  style={{
                    marginBottom: "10px",
                    padding: "8px",
                    borderBottom: "1px solid #ddd",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <span style={{ flex: 1 }}>
                    <strong>{c.nom}</strong> : {c.commentaire}
                  </span>

                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <small style={{ color: "gray", whiteSpace: "nowrap" }}>{date}</small>
                    {user && (user.role === "admin" || user.role === "editor") && (
                      <button
                        onClick={() => handleSupprimerCommentaire(c._id)}
                        style={{
                          background: "transparent",
                          border: "none",
                          color: "red",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                        title="Supprimer ce commentaire"
                      >
                        X
                      </button>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <p>Aucun commentaire pour l’instant.</p>
          )}
        </div>

        {/* Formulaire d'ajout */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "flex-start",
            flexWrap: "wrap",
          }}
        >
          <input
            type="text"
            placeholder="Nom"
            value={nom}
            onChange={(e) => setNom(e.target.value)}
            style={{ flex: "1", padding: "8px" }}
          />

          <textarea
            placeholder="Commentaire"
            value={commentaire}
            onChange={(e) => setCommentaire(e.target.value)}
            rows={1}
            style={{
              flex: "3",
              padding: "8px",
              resize: "both",
            }}
          />

          <button
            onClick={handleAjouterCommentaire}
            style={{
              backgroundColor: "#4CAF50",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              whiteSpace: "nowrap",
              height: "fit-content",
            }}
          >
            Ajouter
          </button>
        </div>

        {message && <p style={{ marginTop: "10px" }}>{message}</p>}
      </div>

      {/* ============ STYLES RESPONSIVES ============ */}
      <style jsx>{`
        @media (max-width: 640px) {
          .article-container {
            margin-left: 0 !important;
            margin-right: 0 !important;
            text-align: left !important;
            padding-left: 10px;
            padding-right: 10px;
          }
        }
      `}</style>
    </div>
  );
};

export default PageArticle;
